import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-links">
        <div className="footer-column">
          <h3>Shop by Category</h3>
          <div className="title-underline"></div>
          <ul>
            <li>
              <Link to="/shop" onClick={toTop}>
                All Products
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h3>About us</h3>
          <div className="title-underline"></div>
          <ul>
            <li>
              <Link to="/about" onClick={toTop}>
                Our Own Brand
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Company</h3>
          <div className="title-underline"></div>
          <ul>
            <li>
              <Link to="/terms" onClick={toTop}>
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/privacy" onClick={toTop}>
                Privacy and Cookie Policy
              </Link>
            </li>
            <li>
              <Link to="/returns" onClick={toTop}>
                Returns Policy
              </Link>
            </li>
            <li>
              <Link to="/shipping" onClick={toTop}>
                Delivery
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-column address-column">
          <h3>Pawluna Ltd</h3>
          <div className="title-underline"></div>
          <p>
            David Ornelas
            <br />
            iokznnha836@outlook.com
            <br />
            11662 harman ave
            <br />
            Los Angeles
            <br />
            90059
            <br />
            United States of America
            <br />
            California
            <br />
            Call us: +1 2728672024
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-logo">
          <i className="fa-solid fa-dog"></i>
          <i className="fa-solid fa-cat"></i>
          <span className="logo-text">Pawluna</span>
        </div>
        <div className="footer-tagline">Enrichment for Pets & People</div>
        <div className="footer-divider"></div>
        <div className="payment-methods">
          <div className="payment-icon paypal">
            <i className="fa-brands fa-paypal"></i> PayPal
          </div>
          <div className="payment-icon visa">
            <i className="fa-brands fa-cc-visa"></i>
          </div>
          <div className="payment-icon mastercard">
            <div className="mc-circle red"></div>
            <div className="mc-circle yellow"></div>
          </div>
        </div>
        <div className="copyright">
          © 2025-2026 Copyright Pawluna Ltd. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
